/* eslint-disable camelcase */
import React, { useContext } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { LicensesRowMenu } from './LicensesRowMenu.tsx';

export const LicensesRow = ({
  license,
  license: {
    name,
    license_definition,
    licenseDefinition,
    number_of_licenses_available,
    numberOfLicensesAvailable,
    license_count,
    licenseCount,
    number_of_licenses_assigned,
    numberOfLicensesAssigned,
  },
  style = {},
  toggleDrawer,
}) => {
  const {
    featureState: { authV3Enabled },
  } = useContext(FeatureContext);

  return (
    <Grid style={style}>
      <Grid
        container
        spacing={0}
        alignItems="center"
        className="Body m-table-row"
        data-testid="PlatformAdminUI-Licensing-LicenseRow-Body"
      >
        <Grid item xs={5}>
          <div
            className="m-table-row__data"
            data-testid="PlatformAdminUI-Licensing-LicenseRow-Name"
          >
            {name.includes('NUC-')
              ? license_definition?.description ?? licenseDefinition.description
              : name}
          </div>
        </Grid>
        <Grid item xs={2}>
          <div
            className="m-table-row__data  m-table-row__cell-align"
            data-testid="PlatformAdminUI-Licensing-LicenseRow-LicenseCount"
          >
            {authV3Enabled ? licenseCount : license_count}
          </div>
        </Grid>
        <Grid item xs={2}>
          <div
            className="m-table-row__data m-table-row__cell-align"
            data-testid="PlatformAdminUI-Licensing-LicenseRow-LicensesAssigned"
          >
            {authV3Enabled
              ? numberOfLicensesAssigned
              : number_of_licenses_assigned}
          </div>
        </Grid>
        <Grid item xs={2}>
          <div
            className="m-table-row__cell-align m-table-row__data"
            data-testid="PlatformAdminUI-Licensing-LicenseRow-LicensesAvailable"
          >
            {authV3Enabled
              ? numberOfLicensesAvailable
              : number_of_licenses_available}
          </div>
        </Grid>
        <Grid item xs={1}>
          <LicensesRowMenu license={license} toggleDrawer={toggleDrawer} />
        </Grid>
      </Grid>
    </Grid>
  );
};
